import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../environments/environment';
import * as moment from 'moment';
import { AuthService } from '../auth.service';
import { HttpClient } from '@angular/common/http';
import { EmployeeService } from '../employee/employee.service';
import { forkJoin } from 'rxjs';

enum SearchMode {
  All = 0,
  Region = 1,
  Rater = 2
}

enum FilterMode {
  All = 1,
  QI = 2,
  Energy = 3
}

@Component({
  selector: 'app-indiv-audits',
  templateUrl: './indiv-audits.component.html',
  styleUrls: ['./indiv-audits.component.css']
})

export class IndivAuditsComponent implements OnInit {
  audits: any[] = [];
  employeeId: number;
  initials: string;
  baseURL = environment.baseUrl;
  filteredAudits: any[] = [];
  preDateFilteredAudits: any[] = [];
  searchTerm: string = '';
  dateSearchOn: boolean = false;

  qiFilterOn: boolean = false;
  energyFilterOn: boolean = false;


  searchMode: number = SearchMode.All; 

  toDate='';
  fromDate ='';
  toDateValue;
  fromDateValue;

  directors: number[] = [54,
    130,
    196,
    151,
    73,
    128,
    86,
    24,
    206,
    3, 39, 185, 78, 97]; 
    
  qi_specialists: number[] = [
    140,
    309,
    115,
    152,
    95,
    219,
    202
  ];


  FilterMode = FilterMode;
  selectedOption: number = FilterMode.All;
  filterMode: number = FilterMode.All;
  isTManager: boolean = false;
  isDirector: boolean = false;
  regions: any;
  selectedRegion: string[] = [];
  isQISpecialist: boolean = false; 
  
  constructor(private http: HttpClient, 
    private auth: AuthService, 
    private el: ElementRef,
    private renderer: Renderer2,
    private employeeService: EmployeeService ) {}

  ngOnInit(): void {
    this.initFunction();
  }

  initFunction = (debug: boolean = false) => {
    this.auth.userProfile$.subscribe(
      (profile) => {
        var data = profile['https://rhv2.com.metadata'];
        var name = data.name.split(' ');
        this.employeeId = debug ? this.employeeId : data.id;

        this.initials = name[0].charAt(0) + name[name.length - 1].charAt(0);
        this.isDirector = this.directors.indexOf(this.employeeId) > -1; 
        this.isQISpecialist = this.qi_specialists.indexOf(this.employeeId) > -1;
        this.isTManager = data.role === 'TManager';

        this.isDirector || this.isQISpecialist ? this.loadAudits_director() : this.loadAudits_nonDirector();

      });

      this.http.get<any>(this.baseURL + '/rhAPI/city/getRegions').subscribe((response) => {

        if (response.Error) {
          alert('Error loading regions: ' + response.Message);
        } else {
          this.regions = response.regions;
        }
      });
      
  }


  debugRestart(employee_id): void {
    this.employeeId = employee_id;
    this.initFunction(true);
  }

  clearDebug(): void {
    this.initFunction();
  }

  onRegionChange(): void {
      if (Array.isArray(this.selectedRegion)) {
          this.searchTerm = this.searchTerm.length > 1 ?  this.searchTerm + ' ' + this.selectedRegion :  this.selectedRegion[0];
      }
  }

  getInitials(name): string {
    if (!name) return '';
    else if (name.includes('West-Chamb')) return 'LC'; //people are more comfortable using LC for Lou West-Chambliss

    const parts = name.trim().split(/[\s]+/);
    const first = parts[0]?.charAt(0) || '';
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (first + last).toUpperCase();
  }

  loadAudits_nonDirector(): void {

    this.employeeService.getEmployees().subscribe((employees) => {

      const employeeTree = this.employeeService.getEmployeeTree(employees.Employees, this.employeeId);
      employeeTree.push(this.employeeId);
      console.log('Employee Tree:', employeeTree);

    const auditsAll$ = this.http.post<any>(this.employeeService.baseURL + `/rhAPI/jobEntry/getIndividualAudits`, { employees : employeeTree });
    const individualQIAudits$ = this.http.post<any>(this.employeeService.baseURL + `/rhAPI/jobEntry/getIndividualQIAuditsByArray`,{ employees : employeeTree });

    forkJoin([auditsAll$, individualQIAudits$]).subscribe({
      next: ([auditAllres, indivQIres]) => {
        console.log(auditAllres, indivQIres);
        if (auditAllres?.Error || indivQIres?.Error) {
          return;
        }

        const energyAudits = auditAllres.Audits.map((audit) => ({
          ...audit,
          showNotes: false,
          schedule_date: new Date(audit.schedule_date).toLocaleDateString('en-US'),
          region: audit.region.trim(),
          initials : this.getInitials(audit.employee_name), 
          category : audit.constage?.toLowerCase().includes('qi') ? FilterMode.QI : FilterMode.Energy
        }));

        energyAudits.map((audit) => {
          audit.audnotes = this.parseNotesForInitials(audit.audnotes, audit.initials);
        });

        const qiAudits = indivQIres.Audits.filter((audit) => audit.score > 0).map((audit) => ({
          ...audit,
          showNotes: false,
          schedule_date: new Date(audit.schedule_date).toLocaleDateString('en-US'),
          region: audit.region,
          initials : audit.employee_name.split(' ').map((name) => name.charAt(0)).join(''),
          category : audit.constage?.toLowerCase().includes('qi') ? FilterMode.QI : FilterMode.Energy
        }));


        this.audits = [...qiAudits, ...energyAudits];
        this.filteredAudits = [...this.audits];
      },
      error: (err) => {
      }
      
      });

    });



  }
  

  /*
  *
  *TO FIX:
  It's currently making an API call for both energy and QI audits even if the user is only a QI specialist.
  *
  */
   loadAudits_director(): void {

    const auditsAll$ = this.http.get<any>(this.employeeService.baseURL + `/rhAPI/jobEntry/auditsAll/`);
    
    const individualQIAudits$ = this.http.get<any>(this.employeeService.baseURL + `/rhAPI/jobEntry/getIndividualQIAuditsByArrayAll`);

    forkJoin([auditsAll$, individualQIAudits$]).subscribe({
      next: ([auditAllres, indivQIres]) => {
        if (auditAllres?.Error || indivQIres?.Error) {
          return;
        }

        const energyAudits = auditAllres.Audits.map((audit) => ({
          ...audit,
          showNotes: false,
          schedule_date: new Date(audit.schedule_date).toLocaleDateString('en-US'),
          region: audit.region.trim(),
          initials : this.getInitials(audit.employee_name), 
          category : audit.constage?.toLowerCase().includes('qi') ? FilterMode.QI : FilterMode.Energy
        }));

        energyAudits.map((audit) => {
          audit.audnotes = this.parseNotesForInitials(audit.audnotes, audit.initials);
        });

        const qiAudits = indivQIres.Audits.filter((audit) => audit.score > 0).map((audit) => ({
          ...audit,
          showNotes: false,
          schedule_date: new Date(audit.schedule_date).toLocaleDateString('en-US'),
          region: audit.region,
          initials : audit.employee_name.split(' ').map((name) => name.charAt(0)).join(''),
          category : audit.constage?.toLowerCase().includes('qi') ? FilterMode.QI : FilterMode.Energy
        }));


        
        if(this.isQISpecialist) {
          //filter to only QI audits
          this.audits = [...qiAudits];
        }else {
          this.audits = [...qiAudits, ...energyAudits];
        }

        this.filteredAudits = [...this.audits];
      },
      error: (err) => {
      }
      
      });


    }

  toggleNotes(audit: any): void {
    audit.showNotes = !audit.showNotes;
  }

 getEmployeeTree(employees, supervisorId) {

    const supervisorMap = {};
    for (const emp of employees) {
      const supId = emp.supervisingrater;
      if (!supervisorMap[supId]) {
        supervisorMap[supId] = [];
      }
      supervisorMap[supId].push(emp);
    }
    function recurse(currentSupervisor, visited) {
      // We'll keep track of all subordinate IDs in 'results'
      let results = [];
  
      const directReports = supervisorMap[currentSupervisor] || [];
      for (const report of directReports) {
        if (visited.has(report.employee_id)) {
          continue;
        }
        visited.add(report.employee_id);
        results.push(report.employee_id);
        const subSubordinates = recurse(report.employee_id, visited);
        results = results.concat(subSubordinates);
      }
      return results;
    }
    return recurse(supervisorId, new Set());
  
  }

  changeSearchType(event): void {
    let type = event.target.value;
    this.searchMode = parseInt(type);
    this.searchTerm = '';
    //let elem = this.el.nativeElement.querySelector('.search-input');

    let placeholderText = '';
    if (this.searchMode === SearchMode.All) {
      placeholderText = 'Search audits...';
    } else if (this.searchMode === SearchMode.Region) {
      placeholderText = "Enter region(s). Separate using spaces";
    } else if (this.searchMode === SearchMode.Rater) {
      placeholderText = 'Enter rater name...';
    }
    let searchBox = document.getElementById('searchBox') as HTMLInputElement;
    if (searchBox) {
        searchBox.placeholder = placeholderText;
    }

    this.processFilters();
  }

  clearAll(): void {
    this.searchTerm = '';
    this.fromDate = '';
    this.toDate = '';
    this.dateSearchOn = false;
    this.selectedRegion = [];
    this.selectedOption = FilterMode.All;
    this.processFilters();
    this.searchMode = SearchMode.All; 
     this.filterMode = FilterMode.All;
    this.onRadioChange(this.filterMode); 

  }

  disableToDates(): void {
    if (!this.fromDate) {
      this.toDate = '';
    }else if(this.toDate < this.fromDate) {
      this.toDate = this.fromDate;
    }
  }

  clearDateRange(): void {
    this.fromDate = '';
    this.toDate = '';
    this.dateSearchOn = false;
    this.processFilters();
  }

  turnOnDateSearch(): void {

    if(this.fromDate && this.toDate) {
    this.fromDateValue = new Date(this.fromDate);
    this.toDateValue = new Date(this.toDate);
    this.dateSearchOn = true;
    this.processFilters();
    }else {
    }

  }


  changeDateRange(inputArray): any[] {
    if (this.dateSearchOn && this.fromDateValue && this.toDateValue) {
          const fromDate = moment.utc(this.fromDateValue);
          const toDate = moment.utc(this.toDateValue);

          return inputArray.filter((audit)=> {
            const auditDate = moment.utc(audit.schedule_date)
            return auditDate.isBetween(fromDate, toDate, undefined, '[]');
          });
    }else {
      return inputArray;
    }
  }


    parseNotesForInitials(notes, initials) {
    // Regex updated to match initials followed by optional spaces and a hyphen

    const markerRegex = /^([A-Z]{2}(?:\s[A-Z]{2})*)\s*-\s*(.+)$/gm;
    const markers = [];
    let m;
  
    while ((m = markerRegex.exec(notes)) !== null) {
      // m[1]: initials (possibly multiple sets)
      // m[2]: note/comment text
      const initialsSet = m[1].split(/\s+/);
  
      markers.push({
        initialsSet,
        noteText: m[2].trim(),
      });
    }
  
    let results = '';
  
    // Looping through markers to extract notes containing the given initials.
    markers.forEach(marker => {
      if (marker.initialsSet.includes(initials)) {
        results += marker.noteText + '\n';
      }
    });
  
    return results;
  }
  
  
  

  searchBoxFilter(inputArray): any[] {
    const searchTermLower = this.searchTerm.toLowerCase();
    
    if(!searchTermLower) {
      return inputArray;
    }else{
      if(this.searchMode === SearchMode.All) {
        return inputArray = this.audits.filter((audit) =>
          Object.values(audit).some((value) =>
            value && value.toString().toLowerCase().includes(searchTermLower)
          )
        );
      }else if(this.searchMode === SearchMode.Region) {

        
        const spaceRegex = /\s[a-zA-Z]/; //space followed by letter
        if(this.searchTerm.endsWith(' ')) {
          return ;
        }
        
        if(searchTermLower.includes(',')) {
          let searchTerms = searchTermLower.split(',').map(term => term.trim());
          return inputArray = this.audits.filter((audit) =>
            searchTerms.some(term => audit.region?.toLowerCase().includes(term))
          );

        }else if(spaceRegex.test(searchTermLower)) {
          let searchTerms = searchTermLower.split(' ').map(term => term.trim());
          return inputArray = this  .audits.filter((audit) =>
            searchTerms.some(term => audit.region?.toLowerCase().includes(term))
          );

        }else {
          return inputArray = this.audits.filter((audit) =>
            audit.region?.toLowerCase().includes(searchTermLower)
          );
        }



      }else if(this.searchMode === SearchMode.Rater) {
        return inputArray = this.audits.filter((audit) =>
          audit.employee_name.toLowerCase().includes(searchTermLower)
        );
      }
    }


  }

  

  stageFilter(inputArray): any[] {
    return inputArray.filter(a => this.filterMode === FilterMode.All || a.category === this.filterMode);
  }

  processFilters(): void {
    this.filteredAudits = this.stageFilter(this.changeDateRange(this.searchBoxFilter([...this.audits])));
  }

  onRadioChange(value): void {
  this.selectedOption = value;
  this.filterMode = value;
  this.processFilters();
   this.processFilters();
  }

  getAverageScore(): number {
    if (!this.filteredAudits.length) return 0;
  
    const totalScore = this.filteredAudits.reduce((sum, audit) => {
      return sum + Number(audit.score); // Convert score to a number
    }, 0);
  
    return parseFloat((totalScore / this.filteredAudits.length).toFixed(2)); // Calculate the average and round to 2 decimals
  }


}
